import React, { useCallback } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import TemplatesPage from "./TemplatesPage";
import { getDataComponentFlattenedRequestState } from "../../../../../reducers/dataComponentReducer";
import { openModalDialog } from "../../../../../actions/layoutActions";
import propTypes from "../../../../../constants/propTypes";
import withRenderOnPermissionActive from "../../../../hocs/withRenderOnPermissionActive";
import {
  getBluechipResources,
  getResourcesV2,
} from "../../../../../utils/bluechipUtils";
import { SCOPES_SELECT } from "../../../../../constants/DataComponents";
import useScope from "../../../../hooks/useScope";

const dataComponentId = "SpecCategoriesGrid";
const dataTemplateCategoryId = "TemplateCategoriesGrid";

const TemplatesContainer = ({
  dataComponent,
  templateCategories,
  scopes,
  openModalDialog,
}) => {
  const scope = useScope();

  const handleOpenCreateModal = useCallback(() => {
    openModalDialog(
      "Spec Template",
      "CreateTemplate",
      { instance: scope?.id ? { scopeId: scope.id } : {} },
      false
    );
  }, [openModalDialog, scope.id]);

  const handleOpenEditModal = useCallback(
    specCategory => {
      openModalDialog(
        `Edit ${specCategory.name}`,
        "CreateTemplate",
        {
          instance: specCategory,
        },
        false
      );
    },
    [openModalDialog]
  );

  const handleOpenDeleteModal = useCallback(
    ({ id, name }) => {
      openModalDialog(
        `Delete ${name}`,
        "StandardDelete",
        {
          id,
          title: name,
          dataComponentId,
        },
        false
      );
    },
    [openModalDialog]
  );

  return (
    <TemplatesPage
      dataComponent={dataComponent}
      templateCategories={templateCategories}
      scopes={scopes}
      onOpenCreateModal={handleOpenCreateModal}
      onOpenEditModal={handleOpenEditModal}
      onOpenDeleteModal={handleOpenDeleteModal}
    />
  );
};

TemplatesContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  templateCategories: PropTypes.arrayOf(propTypes.templateCategory),
  scopes: PropTypes.array,
  openModalDialog: PropTypes.func.isRequired,
};

export const mapStateToProps = state => {
  const dataComponent = getDataComponentFlattenedRequestState(
    dataTemplateCategoryId,
    state
  );
  const templateCategories = getBluechipResources(dataComponent, state);

  const scopesDataComponent = getDataComponentFlattenedRequestState(
    SCOPES_SELECT,
    state
  );

  return {
    templateCategories: templateCategories ?? [],
    scopes: getResourcesV2(scopesDataComponent, state) || [],
    dataComponent: getDataComponentFlattenedRequestState(
      dataComponentId,
      state
    ),
  };
};

export const mapDispatchToProps = {
  openModalDialog,
};

export default withRenderOnPermissionActive(
  connect(mapStateToProps, mapDispatchToProps)(TemplatesContainer),
  ["general-settings-spec-templates"]
);
